import { apiUrl } from "../taskpane";

const STORAGE_KEY = "boq.errorLog";
const MAX_LOCAL = 150;

// Holds the current auth token so the global error listeners can post to the server
let _token = null;

/** Call this whenever the auth token changes (from TaskpaneApp). */
export function setErrorLoggerToken(token) {
  _token = token || null;
}

/** Save an error entry to localStorage and POST it to the server if logged in. */
export function logError(error, context = "") {
  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    timestamp: new Date().toISOString(),
    message: error?.message || String(error),
    stack: error?.stack || "",
    context,
  };

  // Always keep a local copy (works even offline / before login)
  const existing = readErrors();
  const updated = [entry, ...existing].slice(0, MAX_LOCAL);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify([entry])); } catch { /* give up */ }
  }

  // Also POST to server so admins can see everyone's errors
  if (_token) {
    fetch(apiUrl("frontend-errors"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${_token}`,
      },
      body: JSON.stringify({
        message: entry.message,
        stack: entry.stack,
        context: entry.context,
      }),
    }).catch(() => {
      // Never let error-reporting itself throw
    });
  }
}

/** Read all locally stored error entries (newest first). */
export function readErrors() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
}

/** Remove all locally stored errors. */
export function clearErrors() {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * Attach global listeners so uncaught errors and unhandled promise rejections
 * are captured automatically. Call once at app startup.
 */
export function initGlobalErrorCapture() {
  window.addEventListener("error", (e) => {
    logError(e.error || new Error(e.message || "Unknown error"), "window.onerror");
  });

  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason;
    const err = reason instanceof Error ? reason : new Error(String(reason ?? "Unhandled rejection"));
    logError(err, "unhandledrejection");
  });
}
